import { Container, Coins, Good, Asset, CoinsValue, Quantity, Voucher } from './Styles';
import { helper } from 'utils';
import { currentContentConfig } from 'utils/handleCurrentContentConfig';

const Goods = ({ goods, withStyle }) => {
  const getAssetKey = good => {
    const { gTe, iJr, cMRy, id } = good;
    let assetKey = gTe;

    switch (gTe) {
      case 'K':
        assetKey += (iJr ? 'j' : '') + cMRy;
        break;
      case 'BB':
        assetKey += id;
        break;
      default:
        break;
    }

    return assetKey;
  };

  return (
    <Container $withStyle={withStyle}>
      {goods.map((good, index) => {
        const assetKey = getAssetKey(good);
        const asset = currentContentConfig.goodsAssets[assetKey];
        if (asset) {
          const { gTe, vae, quy } = good;
          const isCoins = gTe === 'C';
          const isVoucher = gTe === 'V';
          return isCoins ? (
            <Coins key={index}>
              <Asset src={asset} width={25} />
              <CoinsValue $length={quy.toString().length}>{quy.toLocaleString()}</CoinsValue>
            </Coins>
          ) : (
            <Good key={index}>
              <Asset src={asset} width={65} />
              {quy > 1 && <Quantity $isVoucher={isVoucher}>{`x${quy}`}</Quantity>}
              {isVoucher && <Voucher>{helper.formatVoucherValue(vae)}</Voucher>}
            </Good>
          );
        }
        return null;
      })}
    </Container>
  );
};

export default Goods;
